export const ouraRing5Pdp = {
  hero: {
    heading: "The revolutionary smart ring",
    body: "Oura Ring brings you closer to what matters most—your health. With an updated all-titanium design, this smart ring features Smart Sensing, a new sensing platform that doesn't just measure your biometrics but also adapts to you. It provides insights into over 50+ biometrics and wellness insights including sleep, readiness, activity, heart health, stress, metabolic health and women's health.",
  },
  accordions: {
    description: "Description",
    howItWorks: "How it works",
    sizing: "Sizing",
    subscription: "Subscription",
    techSpecs: "Tech specs",
    integrations: "Integrations",
    shippingAndReturns: "Shipping & returns",
    descriptionContent:
      "Introducing the world's smallest smart ring—Oura Ring 5, built with even more sensing power than previous generations. 40% smaller and ultra lightweight, Oura Ring 5 fits seamlessly in with your life and your style. The updated all-titanium design is more scratch-resistant and comfortable than ever, Oura Ring 5 delivers 50+ health metrics with research-grade accuracy. With 1 week of battery life you can even forget it's on. No more compromises when it comes to tracking your health.",
    howItWorksStep1Title: "Purchase Oura Ring",
    howItWorksStep1Body:
      "After purchase, ŌURA will email you directly with information on the process of finding the best size for you.",
    howItWorksStep2Title: "Set up subscription",
    howItWorksStep2Body:
      "ŌURA will email you directly to set up your Oura Membership and connect your Oura Ring to your device.",
    howItWorksStep3Title: "Connect your Oura Ring to Fullscript",
    howItWorksStep3Body:
      "Take advantage of connecting your lifestyle data into Fullscript to give your practitioner a 360 view.",
    howItWorksStep4Title: "Wear your Oura Ring",
    howItWorksStep4Body: "Collect insights on your sleep, heart rate and more!",
    howItWorksStep5Title: "Have richer conversations with your practitioner",
    howItWorksStep5Body:
      "Save time during appointments by providing practitioners insight into your lifestyle data with your Oura Ring.",
    sizingStep1Title: "Purchase Oura Ring",
    sizingStep1Body:
      "After purchase, ŌURA will email you directly with information and mail a sizing kit.",
    sizingStep2Title: "Choose your finger",
    sizingStep2Body:
      "Your Oura Ring can be worn on any finger. We recommend the index, middle, or ring finger for optimal performance.",
    sizingStep3Title: "Test the fit",
    sizingStep3Body:
      "Your Oura Ring should fit snug and secure on your finger, but not to the point where it's uncomfortable. Try making a fist to ensure there are no gaps between the ring and the finger. Wear the sizing ring with the size number visible on top of the hand.",
    sizingStep3BodyNote:
      "Take your time to find the perfect fit, we recommend wearing your sizing ring for at least 24 hours before confirming your size.",
    sizingStep4Title: "Confirm your size",
    sizingStep4Body:
      "Once you're feeling good about the fit, confirm your size through your email from ŌURA. They will send the ring directly to you.",
    subscriptionContent:
      "Oura Membership unlocks the full potential of the Oura App, allowing you to access detailed insights and personalized guidance. Without Oura Membership, Oura Ring can be used only with limited functionality.",
    techSpecsDimensionsTitle: "Dimensions & Weight",
    techSpecsDimensionsBullet1: "Width: 6.09 mm",
    techSpecsDimensionsBullet2: "Thickness: 2.28 mm",
    techSpecsDimensionsBullet3: "Weight: Starting at 2g (depending on ring size)",
    techSpecsMaterialsTitle: "Materials & Durability",
    techSpecsMaterialsBullet1:
      "Non-allergenic, full-titanium outer and inner body with color-matched interior",
    techSpecsMaterialsBullet2: "IP68 rated, waterproof up to 100m (328 ft)",
    techSpecsMaterialsBullet3:
      "True locking system with self-covering outer gaps for scratch resistance and durability",
    techSpecsBatteryTitle: "Battery & Power",
    techSpecsBatteryBullet1: "6–9 days battery life (based on ring size and usage)",
    techSpecsBatteryBullet2: "0–100% charge in 20–80 minutes",
    techSpecsBatteryBullet3: "10-minute charge delivers a full day of battery life",
    techSpecsBatteryBullet4:
      "Compatible with Oura Ring 5 Charging Case (sold separately) for up to a month of battery life",
    techSpecsSensorsTitle: "Sensors & Technology",
    techSpecsSensorsBullet1: "Red & Infrared LEDs — SpO2 during sleep",
    techSpecsSensorsBullet2:
      "Green & Infrared LEDs — HRV and heart rate 24/7, respiration rate during sleep",
    techSpecsSensorsBullet3: "Digital Temperature Sensor — body temperature",
    techSpecsSensorsBullet4: "3D Accelerometer — movement and activity 24/7",
    techSpecsConnectivityTitle: "Connectivity & Compatibility",
    techSpecsConnectivityBullet1: "Bluetooth Low Energy (BLE)",
    techSpecsConnectivityBullet2: "EMF-safe and FCC-certified with built-in Airplane Mode",
    techSpecsConnectivityBullet3: "iOS and Android, integrates with 40+ third-party apps",
    techSpecsConnectivityBullet4: "Automatic firmware updates via Oura App",
    integrationsIntro:
      "Oura Ring integrates with hundreds of your favorite health and fitness apps.",
    integrationsListTitle: "Compatible apps include:",
    integrationsApp1: "Apple HealthKit",
    integrationsApp2: "Google Health Connect",
    integrationsApp3: "Strava",
    integrationsApp4: "Natural Cycles",
    integrationsApp5: "Mira Fertility & Cycle Tracker",
    integrationsApp6: "The Sculpt Society",
    integrationsApp7: "Cronometer",
    integrationsApp8: "CorePower Yoga",
    integrationsApp9: "Flo",
    integrationsApp10: "Apollo",
    integrationsApp11: "Clue",
    integrationsApp12: "InsideTracker",
    shippingAndReturnsIntro:
      "Standard shipping applies. Please contact <0>Fullscript Support</0> to request a return.",
    shippingAndReturnsDetails:
      "After your return is processed, you'll receive a prepaid shipping label directly from ŌURA. Please ship your ŌURA product back within 14 calendar days. Returns should include everything from the original purchase. You can use any packaging, as long as the items are protected and secured.",
  },
  marketing: {
    sleepAlt: "Person resting in bed with Oura Ring, representing sleep and recovery insights",
    movementAlt: "Person being active with Oura Ring, representing activity and movement tracking",
    heartAlt: "Oura Ring with heart rate visualization, representing heart health monitoring",
    instinctsAlt: "Person with Oura Ring, representing holistic health and body insights",
    sleepHeading: "All you have to do is sleep—the rest will follow",
    sleepBody:
      "Brighter moods, better energy, improved immunity—it all starts with sleep. Wake up to in-depth analysis about your sleep, so you can improve your habits and transform how you feel.",
    movementHeading: "Make every move count",
    movementBody:
      "Oura Ring measures your daily movement (including steps, active calories, training frequency, and more) to create your Activity Score, which changes throughout the day based on how active you are. Your Activity Score ranges from 1-100 and helps you balance movement and recovery.",
    heartHeading: "Take your heart health into your own hands",
    heartBody:
      "The wellbeing of your heart is one of the most powerful contributors to your overall health and longevity. With ŌURA, tune in to how your heart is doing today so you can stay healthy long term.",
    instinctsHeading: "Here to help you trust your instincts",
    instinctsBody:
      "With ŌURA, you'll gain the tools to be the ultimate expert in your health. Spanning stress, sleep, your cycle, pregnancy, and more. Oura Ring can provide revolutionary insights into your wellbeing to help you feel your best, every day.",
  },
  faq: {
    heading: "Frequently asked questions",
    q1: "How accurate is Oura Ring?",
    a1Para1:
      "The sensors in Oura Ring have been tested against laboratory results in multiple validation studies.",
    a1Para3:
      "Wearables differ in where they're worn, the sensors they use, and how they process data. For the most consistent and meaningful insights, it's best to track trends and changes over time within your Oura Ring and Oura App, rather than comparing your Oura results to those from other devices.",
    q2: "Can I wear my Oura Ring in pools, saunas, or ice baths?",
    a2: "Oura Ring is water-resistant up to 100 meters (~330 feet), meaning that you can wear it while showering, swimming, or partaking in recreational diving (e.g. snorkeling), but we don't recommend using your ring while scuba diving or keeping it submerged underwater for over 12 hours. Chlorine will not damage it.\n\nOura Ring operating temperature ranges from \u201310\u201352\u00B0C / 14\u2013125\u00B0F. You can safely wear your ring in the shower, hot tubs, saunas, ice baths, and cryotherapy tanks. However, extended exposure to extreme temperatures (below \u201320\u00B0C / -4\u00B0F or above 60\u00B0C / 140\u00B0F) may lead to battery damage.",
    q3: "What does Oura Ring track?",
    a3Intro: "Oura Ring gives a complete picture of your health, including:",
    a3Readiness: "Readiness",
    a3Sleep: "Sleep",
    a3Activity: "Activity",
    a3StressItem: "<0>Daytime Stress</0> and <1>Resilience</1>",
    a3HeartHealthItem:
      "Heart Health: <0>Cardiovascular Age</0> and <1>Cardio Capacity (VO2 Max)</1>",
    a3MetabolicHealthItem: "Metabolic Health: <0>Glucose</0> and <1>Meals</1>",
    a3WomensHealthItem:
      "Women's Health: <0>Cycle Insights</0>, <1>Fertile Window</1>, and <2>Pregnancy Insights</2>",
    q4: "Can I use Oura Ring without a subscription?",
    a4: "Oura Membership unlocks the full potential of the Oura App, allowing you to access detailed insights and personalized guidance. Without a membership, Oura Ring can be used only with limited functionality.",
    q5: "How do I choose the right size for my Oura Ring?",
    a5: "We recommend you use an Oura Ring sizing kit before selecting your Oura Ring size. The kit includes plastic ring sizers corresponding to Oura Ring sizes, which differ slightly from standard ring sizes (note: half sizes are not available).\n\nFor accuracy, wear the sizing ring for at least 24 hours, including while sleeping, before finalizing your size. If you're between sizes, we recommend choosing the smaller size for a more secure fit.",
  },
} as const;
